import { Box, Text, Title } from "@mantine/core";
import clsx from "clsx";
import React from "react";
import classes from "./section-header.module.css";

interface SectionHeaderProps {
  id?: string;
  isFirstSection?: boolean;
  title: string;
  subTitle?: string;
  badge?: React.ReactNode;
  align?: "center" | "left";
  needsLightTitle?: boolean;
}

export default function SectionHeader({
  id,
  isFirstSection = false,
  title,
  subTitle,
  badge,
  align = "center",
  needsLightTitle = false,
}: SectionHeaderProps) {
  return (
    <Box
      className={classes.wrapper}
      id={id}
      data-align={align}
      data-light-title={needsLightTitle ? "true" : undefined}
    >
      {badge && <Box className={classes.badgeWrapper}>{badge}</Box>}
      <Title
        order={isFirstSection ? 1 : 2}
        className={clsx(classes.title, isFirstSection && classes.firstTitle)}
      >
        {title}
      </Title>
      {subTitle && <Text className={classes.subTitle}>{subTitle}</Text>}
    </Box>
  );
}
